import React, { useState, Suspense } from 'react';
import axios from 'axios';
import ScenarioInput from './ScenarioInput';
import usePlanRetirementForm from './FormHooks';
import {
  StyledForm,
  StyledRadioOption,
  StyledAddRemoveSection,
  StyledGlobalErrors,
  StyledLoading,
  StyledSuccess,
} from './FormStyles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { createPlan } from './RetirementPlannerApi';
import GeneratingPlan from './GeneratingPlan';
import Helmet from 'react-helmet';
import Logo from '../shared/Logo';
import styled from "styled-components";

const baseApiURL =
  process.env.NODE_ENV === 'production'
    ? 'https://finauta-back-staging.herokuapp.com'
    : 'http://localhost:5000';

const getHasPartner = (civilStatus) => {
  if (civilStatus == 'Casado') {
    return true;
  } else {
    return false;
  }
};

let StyledFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100vw;
    height: fit-content;
    min-height: 100vh;
    padding-bottom: 40px;
    background-color: #c9c9c9;
`;

const genInputStyle = (status) => ({
  borderWidth: '1px',
  borderColor: status == 'neutral' ? 'black' : status == 'succeeding' ? 'green' : 'red',
});

const InputError = (message) => message != '' && <Text type="warningMessage">{message}</Text>;

const Form = () => {
  const civilStatusOptions = ['Casado', 'Soltero', 'Viudo', 'Divorciado'];
  let data = new FormData();
  const planRetirement = (cb) => {
    console.log('starting to plan retirement...');
    let reporteSemanasCotizadas = document.getElementById('file').files[0];
    data.set('file', reporteSemanasCotizadas);
    data.set('user_email', inputs.user_email.value);
    data.set('advisor_email', inputs.advisor_email.value);
    data.set('has_partner', getHasPartner(inputs.civil_status.value));
    data.set('civil_status', inputs.civil_status.value);
    if (inputs.alive_parents_num.value != '') {
      data.set('alive_parents_num', inputs.alive_parents_num.value);
    }

    if (inputs.extra_weeks.value != '') {
      data.set('extra_weeks', inputs.extra_weeks.value);
    }

    if (inputs.reactivation_wage.value != '') {
      data.set('reactivation_wage', inputs.reactivation_wage.value);
    }

    data.set('underage_children_num', inputs.underage_children_num.value);
    let scenariosArray = [];
    for (let i = 0; i < inputs.mod_40_scenarios.length; i++) {
      scenariosArray.push(parseInt(inputs.mod_40_scenarios[i].value));
    }
    data.set('mod_40_scenarios', scenariosArray);
    data.set('edge_case', inputs.edge_case.value);
    axios
      .patch(`${baseApiURL}/api/generatePlan/${inputs.advisor_email.value}`, data, {
        timeout: 120000,
      })
      .then((res) => {
        cb(res.data);
      })
      .catch((errors) => {
        cb(errors);
      });
  };
  const {
    handleInputChange,
    handleSubmit,
    addScenario,
    removeScenario,
    handleScenarioChange,
    inputs,
    state,
  } = usePlanRetirementForm(planRetirement);
  console.log(inputs.mod_40_scenarios);
  return (
    <StyledFormContainer>
      <Helmet>
        <title>{'Finauta | Generador de planes'}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <StyledForm onSubmit={handleSubmit}>
        <Logo position="center" style={{ marginBottom: '1em', alignSelf: 'center' }} />
        <Title level={2}>Este generador ya no está disponible 😵</Title>
        <a href="https://internal.finauta.com">-> Ir a nuevo generador de planes de pensión</a>
        {/*
         <label>Reporte de semanas cotizadas*</label>
        <input
          type="file"
          name="file"
          id="file"
          onChange={handleInputChange}
          value={inputs.file.value}
        />
        <label htmlFor="user_email">Correo del cliente*</label>
        <input
          type="text"
          name="user_email"
          id="user_email"
          value={inputs.user_email.value}
          style={genInputStyle(inputs.user_email.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.user_email.error)}
        <label htmlFor="advisor_email">Correo del asesor*</label>
        <input
          type="text"
          name="advisor_email"
          id="advisor_email"
          value={inputs.advisor_email.value}
          style={genInputStyle(inputs.advisor_email.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.advisor_email.error)}
        <label>Estado Civil*</label>
        {civilStatusOptions.map((civilStatusOption) => (
          <StyledRadioOption>
            <input
              type="radio"
              name="civil_status"
              label={civilStatusOption}
              checked={inputs.civil_status.value === civilStatusOption}
              id={civilStatusOption}
              value={civilStatusOption}
              style={genInputStyle(inputs.civil_status.status)}
              onClick={handleInputChange}
            />
            <Text type="body1">{civilStatusOption}</Text>
          </StyledRadioOption>
        ))}
        {InputError(inputs.civil_status.error)}
        <label htmlFor="underage_children_num">Número de hij@s menores de 16 en el retiro*</label>
        <input
          type="number"
          name="underage_children_num"
          id="underage_children_num"
          value={inputs.underage_children_num.value}
          style={genInputStyle(inputs.underage_children_num.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.underage_children_num.error)}
        <label htmlFor="alive_parents_num">Número de padres vivos</label>
        <input
          type="number"
          name="alive_parents_num"
          id="alive_parents_num"
          value={inputs.alive_parents_num.value}
          style={genInputStyle(inputs.alive_parents_num.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.alive_parents_num.error)}
        <label htmlFor="reactivation_wage">Salario de reactivación</label>
        <input
          type="number"
          name="reactivation_wage"
          id="reactivation_wage"
          value={inputs.reactivation_wage.value}
          style={genInputStyle(inputs.reactivation_wage.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.reactivation_wage.error)}
        <label htmlFor="extra_weeks">Semanas extra</label>
        <input
          type="number"
          name="extra_weeks"
          id="extra_weeks"
          value={inputs.extra_weeks.value}
          style={genInputStyle(inputs.extra_weeks.status)}
          onChange={handleInputChange}
        />
        {InputError(inputs.extra_weeks.error)}

        <StyledAddRemoveSection>
          <label>Escenarios*</label>
          <input
            type="button"
            value="Quitar el último escenario"
            onClick={removeScenario}
            style={{ marginLeft: '1em' }}
          />
          <input
            type="button"
            value="Agregar otro escenario"
            onClick={addScenario}
            style={{ marginLeft: '1em' }}
          />
        </StyledAddRemoveSection>

        <Text type="body">Ojo: El escenario de aportación máxima se agrega automáticamente</Text>
        {inputs.mod_40_scenarios.map((scenario, idx) => (
          <ScenarioInput
            key={`scenario-${idx}`}
            idx={idx}
            errorDisplay={InputError(scenario.error)}
            style={genInputStyle(scenario.status)}
            scenarioState={scenario}
            handleScenarioChange={handleScenarioChange}
          />
        ))}
        <StyledRadioOption style={{ margin: '1em 0' }}>
          <input
            type="checkbox"
            defaultChecked={inputs.edge_case.value}
            onChange={handleInputChange}
            id="edge_case"
            name="edge_case"
          />
          <Text type="body1"> Enviar a Finauta para revisión</Text>
        </StyledRadioOption>
        <input type="submit" value="Generar plan de pensión" style={{ alignSelf: 'center' }} />

        {state.message != '' && (
          <StyledSuccess>
            <Title level={5}>{state.message}</Title>
          </StyledSuccess>
        )}
        {state.submitting != '' && (
          <StyledLoading>
            <Title level={5}>{state.submitting}</Title>
          </StyledLoading>
        )}
        {state.errors.length > 0 && (
          <StyledGlobalErrors>
            <Title level={5}>Oops! Parece que hubo uno o mas errores:</Title>
            <ul style={{ justifySelf: 'flex-start', width: '100%' }}>
              {state.errors.map((error) => (
                <li>
                  <Text type="body">{error}</Text>
                </li>
              ))}
            </ul>
          </StyledGlobalErrors>
        )}
        */}
      </StyledForm>
    </StyledFormContainer>
  );
};

export default Form;
